// extracted by mini-css-extract-plugin
module.exports = {"container":"Common_container__2-AqK","containerHigh":"Common_containerHigh__WTf11"};